import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Input, Row, Label } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import { useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { getUserList } from '../../store/userSlice';
import { service } from '../../shared/_services/api_service';
import SweetAlert from 'sweetalert2';


const UserListTable = () => {
  const storeVar = useSelector(state => state.user)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 800;
  const [localStartDate, setLocalStartDate] = useState('');
  const [localEndDate, setLocalEndDate] = useState('');
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    startDate: '',
    endDate: ''
  });

  const applyDateFilter = () => {
    setFormVar(prev => ({
      ...prev,
      startDate: localStartDate,
      endDate: localEndDate,
      offset: 0,
      currentPage: 1
    }));
  };

  useEffect(() => {
    dispatch(getUserList(formVar.limit, formVar.offset, formVar.keyword, formVar.startDate, formVar.endDate))
  }, [formVar.startDate, formVar.endDate]);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getUserList(formVar.limit, offset, formVar.keyword, formVar.startDate, formVar.endDate))
  };
  const searchState = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: e.target.value }))
    searchWithDelay(e.target.value)
  }
  const searchWithDelay = (keyword) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(getUserList(formVar.limit, formVar.offset, keyword, formVar.startDate, formVar.endDate))
    }, typingDelay);
    setTypingTimer(timer);
  };

  const exportToCSV = async () => {
    try {
      // Fetch matching users CSV from backend
      const response = await service.exportUsersCSV(formVar.keyword, formVar.startDate, formVar.endDate);
      const csvContent = response?.data;

      if (!csvContent) {
        SweetAlert.fire({
          icon: 'info',
          title: 'No Data',
          text: 'No data returned from server.'
        });
        return;
      }

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `user_list_${new Date().toISOString().slice(0, 10)}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting users to CSV:', error);
      SweetAlert.fire({
        icon: 'error',
        title: 'Export Failed',
        text: 'Could not export user list to CSV.'
      });
    }
  };




  const onTestNavigate = (data) => {
    navigate('/exam-list/' + layoutURL + '?id=' + data._id)
  }



  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row className='align-items-end'>
              <Col md="3" sm="6">
                <Label for="yourInputId" className='f-w-600'>Search Student</Label>
                <Input className="form-control" placeholder='Search...' type="text" id="yourInputId"
                  value={formVar.keyword} onChange={(e) => searchState(e)}
                />
              </Col>
              <Col md="2" sm="6">
                <Label for="startDate" className='f-w-600'>Start Date</Label>
                <Input className="form-control" type="date" id="startDate"
                  value={localStartDate} onChange={(e) => setLocalStartDate(e.target.value)}
                />
              </Col>
              <Col md="2" sm="6">
                <Label for="endDate" className='f-w-600'>End Date</Label>
                <Input className="form-control" type="date" id="endDate"
                  value={localEndDate} onChange={(e) => setLocalEndDate(e.target.value)}
                />
              </Col>
              <Col md="2" sm="6" className='d-flex align-items-center mt-3 mt-md-0'>
                <button 
                  onClick={applyDateFilter}
                  className="btn btn-info btn-sm w-100"
                >
                  Apply Filter
                </button>
              </Col>
              <Col md="3" sm="6" className='d-flex justify-content-end align-items-center mt-3 mt-md-0'>
                <button 
                  onClick={exportToCSV}
                  className="btn btn-primary btn-sm d-flex align-items-center gap-2 w-100 justify-content-center"
                >
                  <i className="fa fa-download"></i> Export CSV
                </button>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Email Id</th>
                  <th scope='col'>Phone Number</th>
                  <th scope='col'>Joined Date</th>
                  {/* <th scope='col'>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {storeVar.examUserList?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.name}</td>
                    <td >{item.email}</td>
                    <td >{item.phoneNumber}</td>
                    <td >{item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A'}</td>
                    {/* <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-secondary action-icon'>
                          <i className="fa fa-book fa-lg" onClick={() => onTestNavigate(item)}></i>
                          <div className="tooltipCustom">Exams</div>
                        </div>

                      </div>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalUser <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalUser > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalUser}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>



    </Fragment>
  );
};

export default UserListTable;
